import { EnterpriseParams } from '@/backend/access/enterprise/types';
import { File } from './file';

export class Enterprise {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  propelOrgId: string;
  title: string;
  description: string;
  file?: File;

  constructor(params: EnterpriseParams) {
    this.id = params.id;
    this.propelOrgId = params.propelOrgId;
    this.title = params.title;
    this.description = params.description;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.file = params.file ? new File(params.file) : undefined;
  }
}
